<template>
    <DForm @submit.prevent="submitForm">
        <ProductSelection
            :multiple="false"
            :selected-product-group="selectedProductGroup"
            :selected-products="selectedProduct"
            :required="true"
            class="row-margin"
            @update="updateProduct"
            @reset-product-id="resetProductId"
        />

        <DFormRow
            :label="__('customers.reseller_products.form.billing_product_plan')"
            :is-required="true"
            :error="errors.billing_product_plan_id"
        >
            <DSelect
                id="billing_product_plan"
                v-model="form.billing_product_plan_id"
                :options="productPlans"
                :placeholder="__('customers.reseller_products.form.billing_product_plan')"
                :is-valid="isFormFieldValid('billing_product_plan_id')"
                :disabled="!form.product_id"
            />
        </DFormRow>
        <DFormRow
            :label="__('customers.reseller_products.form.display_product_plan')"
            :is-required="true"
            :error="errors.display_product_plan_id"
        >
            <DSelect
                id="display_product_plan"
                v-model="form.display_product_plan_id"
                :options="productPlans"
                :placeholder="__('customers.reseller_products.form.display_product_plan')"
                :is-valid="isFormFieldValid('display_product_plan_id')"
                :disabled="!form.product_id"
            />
        </DFormRow>

        <DFormControls
            :cancel-route="$route('customers.customers.reseller-products.index', {customer: customer.id})"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script>
import ProductSelection from '~@/Components/Products/Products/ProductSelection'

export default {
    name: 'ResellerProductForm',
    components: { ProductSelection },
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        customer: {
            type: Object,
            default: () => { return {} }
        },
        resellerProduct: {
            type: Object,
            default: () => { return {} }
        },
        availableProductPlans: {
            type: Array,
            default: () => { return [] }
        }
    },
    emits: ['submit'],
    data () {
        return {
            productId: this.resellerProduct?.product_id ?? null,
            productPlans: this.availableProductPlans,
            form: this.$inertia.form({
                product_id: this.resellerProduct?.product_id ?? null,
                billing_product_plan_id: this.resellerProduct?.billing_product_plan_id ?? null,
                display_product_plan_id: this.resellerProduct?.display_product_plan_id ?? null
            })
        }
    },
    computed: {
        selectedProductGroup () {
            if (this.productId) {
                return this.resellerProduct.product.product_group.id
            }

            return 0
        },
        selectedProduct () {
            if (this.productId) {
                return [{
                    value: this.resellerProduct.product.id,
                    label: `${this.resellerProduct.product.name}${this.resellerProduct.product.retired ? ' (' + this.__('products.products.index.retired') + ')' : ''} (${this.resellerProduct.product.id})`
                }]
            }

            return []
        }
    },
    methods: {
        submitForm () {
            this.$emit('submit', this.form)
        },
        updateProduct (value) {
            const valueChanged = Number(this.form.product_id) !== Number(value.value)

            this.form.product_id = value.value
            this.productPlans = value.plans

            // Reset ProductPlans on Product change.
            if (valueChanged) {
                this.form.billing_product_plan_id = null
                this.form.display_product_plan_id = null
            }
        },
        resetProductId () {
            this.productId = null
            this.form.product_id = null
            this.form.billing_product_plan_id = null
            this.form.display_product_plan_id = null
        }
    }
}
</script>
<style lang="scss" scoped>
.row-margin {
    margin-bottom: 25px !important;
    grid-gap: 0
}
</style>
